import { Exception } from '@adonisjs/core/exceptions'

export default class InternalServerErrorException extends Exception {
  static status = 500
  code = 'E_SERVERERROR'
  message = '服务器出现问题，请联系客服人员'

  constructor(message?: string, help?: string) {
    super(message)
    if (message) this.message = message
    if (help) this.help = help
  }
}
